import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { useIntlTranslate } from "../../../../hooks";
import { Mobile, NotMobile } from "../../../../hocs/Responsive";

import { Button } from "../../../button/Button";
import { Icon } from "../../../icon/Icon";

import "./DrilldownLink.scss";
import { widgetTitles } from "../widgetTitles";
import { DrilldownKeys } from "../../../../helpers/reports.helper.types";

interface Props {
  drilldown: DrilldownKeys;
}

export const DrilldownLink = ({ drilldown }: Props) => {
  const translate = useIntlTranslate();
  const ariaLabel = translate("aria_see_more_blocked_by", {
    blockedBy: translate(widgetTitles[drilldown].long),
  });

  return (
    <Fragment>
      <Mobile>
        <Button
          as={Link}
          to={`/drilldown/${drilldown}`}
          className={"widget__link widget__button"}
          aria-label={ariaLabel}
        >
          <Icon icon="fa-regular fa-angle-right" />
        </Button>
      </Mobile>
      <NotMobile>
        <div className="widget__button">
          <Button
            as={Link}
            to={`/drilldown/${drilldown}`}
            isOutline
            pillButton
            size={"small"}
            aria-label={ariaLabel}
          >
            <span className="widget__button__content">
              <FormattedMessage id="see_more" />
            </span>
          </Button>
        </div>
      </NotMobile>
    </Fragment>
  );
};
